import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { JumpcloudConnector } from '../../connector';

export const MdmService = IntegrationService.make({
  connector: JumpcloudConnector,
  name: Integration_Service_Names_Enum.Mdm,
});
